import type { IconData } from '@stacksjs/iconify-core'

export const intercomAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M20 23H4a3.003 3.003 0 0 1-3-3V4a3.003 3.003 0 0 1 3-3h16a3.003 3.003 0 0 1 3 3v16a3.003 3.003 0 0 1-3 3\" opacity=\".5\"/><path fill=\"currentColor\" d=\"M12 19a10.8 10.8 0 0 1-6.644-2.06a1 1 0 0 1 1.288-1.532A9 9 0 0 0 12 17a9 9 0 0 0 5.361-1.595a1 1 0 0 1 1.282 1.535A10.8 10.8 0 0 1 12 19m-6-6a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1m4 2a1 1 0 0 1-1-1V6a1 1 0 0 1 2 0v8a1 1 0 0 1-1 1m4 0a1 1 0 0 1-1-1V6a1 1 0 0 1 2 0v8a1 1 0 0 1-1 1m4-2a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default intercomAlt
